import ObfuscationInstructionOverlayGuard from './ObfuscationInstructionOverlayGuard';

export default ObfuscationInstructionOverlayGuard;
